import React from "react";

export const ReturnOptionCard = ({
  heading,
  description,
  isChecked = false,
  onClick,
  itemDescription,
  itemIsAllowed,
  itemIsRefund,
  storeConfigState,
  incentiveMsg,
  keyID,
  extraDescription,
}) => {
  return (
    <label
      className={`return-option-component  ${isChecked && "active"}`}
      key={keyID}
    >
      <h2 className="heading_refund_return_card">{heading}</h2>
      <div className="return_option_extra_description">
        <p>{extraDescription}</p>
      </div>
      {itemDescription.map(
        (item) =>
          item.isShow && (
            <p className="choose__item_text description" key={item.id}>
              {item.info}
            </p>
          )
      )}

      <div className="error-main ">
        {itemIsAllowed && (
          <span className="info__error">
            {storeConfigState?.themeConfigOthers?.return_policy_url ? (
              <a
                className="info__error_policy"
                href={storeConfigState?.themeConfigOthers?.return_policy_url}
                target="_blank"
                rel="noreferrer"
              >
                {storeConfigState?.themeConfig?.errors_violated_policy}
              </a>
            ) : (
              storeConfigState?.themeConfig?.errors_violated_policy
            )}
          </span>
        )}
        {itemIsRefund === false && (
          <span className="info__error saara-justify-content-center">
            {incentiveMsg}
          </span>
        )}
      </div>

      <div className="return-option-container">
        <input
          className="return_option_radio radio_option"
          name="return_radio"
          type="radio"
          onClick={onClick}
          checked={isChecked}
        />
      </div>
    </label>
  );
};
